module.exports = __webpack_public_path__ + "img/banner.26d4c969.png";